import React, { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { OverlayPanel } from "primereact/overlaypanel";
import { ProgressSpinner } from "primereact/progressspinner";
import { Tag } from "primereact/tag";
import { useTranslation } from "react-i18next";
import BusinessCustomersActions from "../../Redux/transition/customers/business-customer.reducer";
import "../../Styles/components/tags.scss";

const AudienceMemberTagsCell = ({ businessCustomerId }) => {
    const { t } = useTranslation("common");
    const dispatch = useDispatch();
    const overlayRef = useRef(null);
    const [requestedBcId, setRequestedBcId] = useState(null);

    const { customerSummary, fetchingCustomerSummary } = useSelector((state) => state.businessCustomers);

    const handleClick = (e) => {
        e.stopPropagation();
        if (!businessCustomerId) {
            return;
        }
        setRequestedBcId(businessCustomerId);
        overlayRef.current?.show(e);
        dispatch(BusinessCustomersActions.customerSummaryRequest(businessCustomerId));
    };

    const isActiveRequest = requestedBcId === businessCustomerId;
    const tags = isActiveRequest ? (customerSummary?.tags ?? []) : [];
    const isLoading = fetchingCustomerSummary && isActiveRequest;

    if (!businessCustomerId) {
        return <div className="text-left" />;
    }

    return (
        <>
            <div
                className="flex align-items-center audience-member-tags-trigger"
                onClick={handleClick}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                        handleClick(e);
                    }
                }}
            >
                <span className="view-list mb-0">{t("business_customers.audience_view_tags")}</span>
                <i className="pi pi-arrow-up-right arrow-subs" />
            </div>
            <OverlayPanel
                ref={overlayRef}
                showCloseIcon
                className="subsOverlay audience-member-tags-overlay"
                onHide={() => setRequestedBcId(null)}
            >
                {isLoading ? (
                    <div className="flex justify-content-center p-2">
                        <ProgressSpinner style={{ width: "24px", height: "24px" }} />
                    </div>
                ) : tags.length ? (
                    <div className="audience-member-tags-popover">
                        {tags.map((tag) => (
                            <Tag key={tag.id ?? tag.name ?? tag.label} className="tag-div-main">
                                <span className="tag-class">{tag.name ?? tag.label}</span>
                            </Tag>
                        ))}
                    </div>
                ) : (
                    <p className="mb-0 normal_hint">{t("business_customers.audience_no_member_tags")}</p>
                )}
            </OverlayPanel>
        </>
    );
};

export default AudienceMemberTagsCell;
